import { Box, Button, Popover, Stack, Tooltip, Typography } from "@mui/material";
import { useRouter } from "next/router";
import { useState } from "react";
import { AddonCreditsModal } from "../addon-credits-modal";
import { Iconify } from "@sdf/base";

export const CreditsUsed = ({
  anchorEl,
  handleClose,
  remainingCredits,
  totalCredits,
  isUserSubscribed,
}: {
  anchorEl: HTMLElement | null;
  handleClose: () => void;
  remainingCredits: number;
  totalCredits: number;
  isUserSubscribed: boolean;
}) => {
  const [openCreditsModal, setOpenCreditsModal] = useState(false);
  const { push } = useRouter();

  const handleAddCredits = () => {
    setOpenCreditsModal((prev) => !prev);
  };

  const handleUpgrade = () => {
    push('/subscription');
  };

  return (
    <Popover
      open={Boolean(anchorEl)}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      slotProps={{
        paper: {
          sx: {
            mt: 1,
            p: 2,
            border: '2px solid',
            borderColor: (theme) => theme.palette.background.border,
            backgroundColor: (theme) => theme.palette.background.secondary,
            borderRadius: 1,
            minWidth: 300,
            maxWidth: 400,
          },
        },
      }}
    >
      <Stack>
        <Stack
          sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: '5px' }}
        >
          <Typography sx={{ fontWeight: 700, fontSize: '18px', lineHeight: '30px' }}>
            {remainingCredits?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
          </Typography>
          <Typography sx={{ fontWeight: 400, fontSize: '14px', lineHeight: '22px' }}>
            /{totalCredits.toLocaleString('en-US')} Credits Left
          </Typography>
          <AddonCreditsModal openModal={openCreditsModal} closeModal={handleAddCredits} />
        </Stack>
      </Stack>
      <Stack direction="row" spacing={1} sx={{ display: "flex", justifyContent: "space-between" }}>
        <Button
          sx={{ backgroundColor: '#7B35EF', color: '#ffffff', height: '45px', width: '151px' }}
          onClick={isUserSubscribed ? handleAddCredits : handleUpgrade}
        >
          {isUserSubscribed ? 'Add Credits' : 'Upgrade'}
        </Button>
        {!isUserSubscribed && (
          <Tooltip title={'You must have an active All Access Plan to use Addon credits'}>
            <Box sx={{ display: 'inline-flex', alignItems: 'flex-end' }}>
              <Iconify
                icon={'heroicons-outline:information-circle'}
                width={'20px'}
                height={'20px'}
                color={(theme) =>theme.palette.text.primary}
              />
            </Box>
          </Tooltip>
        )}
      </Stack>
    </Popover>
  );
};
